"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupEventProbabilities = groupEventProbabilities;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const getOutcomeKey_1 = require("../../getOutcomeKey");
const helpers_1 = require("./helpers");
/*
  Функция которая преобрзаует EventProbabilitiesMarket в древовидный формат,
  для удобного сравнения с предыдущими значениями

  Фильтруем:
   - Если у пробса нет virtualMarketId
   - Если у нас нет информации о полученном виртуальном маркете
   - Пробс имеет статус Settled
   - Пробсы у которых по которым мы получили данные но категория к которой они принадлежат не соответствует спорту события
   - Пробсы у которых в параметрах есть playerId но у нас нет данных по данному игроку
*/
function groupEventProbabilities(eventMarkets, vMarketsInfo, vCategoriesInfo, sportId, players, probsWithPlayerIdParam) {
    const res = {};
    for (const eventMarket of eventMarkets) {
        for (const probability of eventMarket.probabilities) {
            if (probability.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Settled) {
                continue;
            }
            const vMarketId = probability.virtualMarketId;
            if (vMarketId === undefined) {
                continue;
            }
            const vMarketInfo = vMarketsInfo[vMarketId];
            if (vMarketInfo === undefined) {
                continue;
            }
            const { vCategoryId } = vMarketInfo;
            const vCategoryInfo = vCategoriesInfo[vMarketInfo.vCategoryId];
            if (vCategoryInfo === undefined) {
                continue;
            }
            if (!(0, helpers_1.sportBelongsToCategory)(sportId, vCategoryInfo)) {
                continue;
            }
            const outcomeKey = (0, getOutcomeKey_1.getOutcomeKey)(probability);
            const probsHasPlayerIdParameter = probsWithPlayerIdParam[outcomeKey] !== undefined;
            if (probsHasPlayerIdParameter) {
                const playerNotFound = players[probsWithPlayerIdParam[outcomeKey]] === undefined;
                if (playerNotFound) {
                    continue;
                }
            }
            if (res[vCategoryId] === undefined) {
                res[vCategoryId] = {};
            }
            if (res[vCategoryId][vMarketId] === undefined) {
                res[vCategoryId][vMarketId] = {};
            }
            res[vCategoryId][vMarketId][outcomeKey] = probability;
        }
    }
    return res;
}
//# sourceMappingURL=groupEventProbabilities.js.map